import { Post } from '../helpers';
import { EventGroup } from '@/types/projects.types';

export function CreateProjectGroup(
  channel: number,
  name: string,
  projectUuids: string[],
  adminIds: number[]
): Promise<EventGroup> {
  return Post({
    path: `/v3/admin/channel/${channel}/event-groups`,
    body: { name, eventUuids: projectUuids, adminIds },
  });
}
